"use client";

import React, { useCallback, useEffect, useMemo } from "react";
import ProductCard from "@/components/ProductCard";
import { useLanguage } from "@/lib/config/useLanguage";
import {
  pushProductClickEvent,
  pushProductImpressionEvent,
} from "@org/ui";

type ProductGridWithAnalyticsProps = {
  items?: any[];
  listName?: string;
  className?: string;
};

const DEFAULT_GRID_CLASS =
  "grid w-full gap-3 md:gap-4 grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4";

export default function ProductGridWithAnalytics({
  items,
  listName,
  className,
}: ProductGridWithAnalyticsProps) {
  const resolvedListName = listName || "Catalog";
  const { currency } = useLanguage();
  const currencyCode = currency?.code;

  const safeItems = useMemo(
    () => (Array.isArray(items) ? items.filter(Boolean) : []),
    [items]
  );

  useEffect(() => {
    if (!safeItems.length) return;
    pushProductImpressionEvent(
      safeItems.map((item, index) => ({
        ...item,
        position: index + 1,
        list: resolvedListName,
      })),
      {
        currencyCode,
        listName: resolvedListName,
        startPosition: 1,
      }
    );
  }, [currencyCode, resolvedListName, safeItems]);

  const handleClick = useCallback(
    (item: any, index: number) => {
      pushProductClickEvent(
        {
          ...item,
          position: index + 1,
          list: resolvedListName,
        },
        {
          currencyCode,
          listName: resolvedListName,
          startPosition: 1,
        }
      );
    },
    [currencyCode, resolvedListName]
  );

  return (
    <div className={className || DEFAULT_GRID_CLASS}>
      {safeItems.map((item, index) => (
        <div key={item?.id ?? index} onClick={() => handleClick(item, index)}>
          {/* Первый ряд мобильной сетки (2 карточки) грузим сразу, остальные — лениво. */}
          <ProductCard item={item} eagerImage={index < 2} />
        </div>
      ))}
    </div>
  );
}
